import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import { userId } from '../../../reducers/currentUser/currentUser.reducer';
import {
  loadForProjectManager,
  sortByDate,
  sortByProjectName,
} from '../../../reducers/workOrder/workOrders.actions';
import { loading, submittedWorkOrders } from '../../../reducers/workOrder/workOrders.reducer';
import { Spinner } from '../../Spinner/Spinner';
import WorkOrderList from '../../WorkOrderList/WorkOrderList';
import './ProjectManagerHome.css';

// eslint-disable-next-line object-curly-newline
export class ProjectManagerHome extends React.Component {
  componentDidMount() {
    this.props.load();
  }

  render() {
    return (
      <span>
        <Button onClick={() => this.props.sortDate()}>Sort Date</Button> &nbsp;&nbsp;&nbsp;
        <Button onClick={() => this.props.sortProject()}>Sort Project</Button>
        <LinkContainer to="/pm/workorders/new" >
          <Button className="pull-right" bsStyle="primary" >Create New DWR</Button>
        </LinkContainer>
        <br />
        {this.props.loading && <Spinner isLoading /> }
        <WorkOrderList workOrders={this.props.workOrders} url="/pm" />
      </span>
    );
  }
}

ProjectManagerHome.propTypes = {
  load: PropTypes.func.isRequired,
  sortDate: PropTypes.func.isRequired,
  sortProject: PropTypes.func.isRequired,
  workOrders: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  loading: PropTypes.bool.isRequired,
};


export const mapDispatchToProps = (dispatch) => {
  let dwrTypes = '';
  // eslint-disable-next-line no-undef
  if (window.location.pathname.endsWith('approved')) {
    dwrTypes = 'approved';
  // eslint-disable-next-line no-undef
  } else if (window.location.pathname.endsWith('submitted')) {
    dwrTypes = 'submitted';
  }

  return ({
    load: () => dispatch(loadForProjectManager(dwrTypes)),
    sortDate: () => dispatch(sortByDate()),
    sortProject: () => dispatch(sortByProjectName()),
  });
};

export const mapStateToProps = state => ({
  workOrders: submittedWorkOrders(state),
  loading: loading(state),
  id: userId(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProjectManagerHome);
export const ConnectedProjectManagerApprovedHome = connect(mapStateToProps, mapDispatchToProps)(ProjectManagerHome);
export const ConnectedProjectManagerSubmittedHome = connect(mapStateToProps, mapDispatchToProps)(ProjectManagerHome);



// WEBPACK FOOTER //
// ./src/components/ProjectManager/Home/ProjectManagerHome.jsx